<template>
    <v-text-field 
        :label="modelValue.title"
        :name="modelValue.name" 
        :id="modelValue.id" 
        :model-value="modelValue.value" 
        :error-messages="modelValue.error"
        @update:model-value="updateText"
        type="text"
        bg-color="white"
    >
        <template v-slot:append-inner v-if="modelValue.mandatory">
            <v-icon color="red" size="small">mdi-asterisk</v-icon>
        </template>
    </v-text-field>
</template>
<script>

export default {
    name: 'TextFieldComponent',

    props: ['modelValue',], //modelValue - it's the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    data() {
        return {
            
        };
    },

    methods: {
        updateText(newValue) {
            console.log('TextFieldComponent updateText', newValue);
            this.$emit('update:modelValue', {                
                ...this.modelValue,
                value: newValue, // Set new value
                error: '', // Reset any previous error
            });
        }
    }

}
</script>

<style scoped>
</style>